import { Component } from '@angular/core';

@Component({
  selector: 'app-landing-copyright',
  templateUrl: './landing-copyright.component.html',
  styleUrls: ['../landing/landing.component.scss', './landing-copyright.component.scss']
})
export class LandingCopyrightComponent {

}
